import { FormDataBusinessInformation } from ".";
import { DEFAULT_PAYER_INDUSTRY } from "../../utils/industry";

export const getBusinessFormEmptyValues = (): FormDataBusinessInformation => ({
  legalBusinessName: "",
  dba: "",
  taxClassification: null,
  taxId: "",
  industry: DEFAULT_PAYER_INDUSTRY,
  email: "",
  usePersonalEmail: false,
  phone: {
    countryCode: "1",
    phoneNumber: ""
  },
  website: "",
  noWebsite: false,
  numberOfEmployees: "None",
  address: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: ""
  },
  canadaQuebecEnterpriseNumber: "",
  stateOfIncorporation: null,
  yearOfIncorporation: null
});
